import Breadcrumb from 'components/Breadcrumb'
import { Page, pages } from 'pages/pages'
import React, { useEffect, useState } from 'react'
import {
  FacilityVisitorAddress,
  FacilityVisitorCalendarContainer,
  FacilityVisitorCalendarSubContainer,
  FacilityVisitorContainer,
  FacilityVisitorCourtContainer,
  FacilityVisitorDescription,
  FacilityVisitorImage,
  FacilityVisitorImageContainer,
  FacilityVisitorItemContainer,
  FacilityVisitorLocationIconContainer,
  FacilityVisitorRightContainer,
  FacilityVisitorTitle,
  FacilityVisitorToolbarContainer,
} from './FacilityVisitor.styled'
import { MdLocationOn } from 'react-icons/md'
import Button from 'components/Button/Button'
import Court from 'components/Court'
import CalendarMonth from 'components/CalendarMonth/CalendarMonth'
import CalendarToolbar from 'components/CalendarToolbar/CalendarToolbar'
import BookingCourt from 'components/BookingCourt'
import { useHistory, useParams } from 'react-router'
import { Location, LocationDetail } from 'models/location'
import { useAppDispatch, useAppState } from 'store'
import { appointmentActions } from 'store/slices/appointments/appointments.slice'
import PageLoader from 'components/PageLoader/PageLoader'
import { Day } from 'react-modern-calendar-datepicker'
import { SelectTypes } from 'components/Select/Select.props'
import { userActions } from 'store/slices/users/users.slice'
import Modal from 'components/Modal'

const FacilityVisitor = () => {
  // Future implementation
  // const [favorite, setFavorite] = useState<boolean>(false)

  const FACILITY_BREADCRUM: Page[] = [pages.Home, pages.FacilityVisitor]
  const { push } = useHistory()
  const [loadingFlg, setLoadingFlg] = useState<boolean>(true)
  const [locationInfo, setLocationInfo] = useState<LocationDetail | null>(null)
  const [contactButtonText, setContactButtonText] = useState<string>('Contact')

  const today = new Date()
  const [calendarDay, setCalendarDay] = useState<Day>({
    day: today.getDate(),
    month: today.getMonth() + 1,
    year: today.getFullYear(),
  })
  const [calendarToolbarDay, setCalendarToolbarDay] = useState<Date>(today)
  const [selectDate, setSelectDate] = useState<Date>(today)

  const { location, loading } = useAppState(state => state.appointments)
  const { user } = useAppState(state => state.auth)
  const { waiverSigned, waiverUrl } = useAppState(state => state.user)
  const [showWaiver, setShowWaiver] = useState<boolean>(false)

  const params = useParams<Location>()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const fetchAll = async () => {
      await dispatch(
        appointmentActions.getLocation(params ? params.locationId : '')
      )
      await dispatch(
        userActions.getWaiverStatusForUser({
          locationId: params?.locationId ?? '',
          userId: user?.id.toString() ?? '',
        })
      )
    }
    fetchAll()
  }, [])

  useEffect(() => {
    if (loading === 'succeeded') {
      setLoadingFlg(false)
      setLocationInfo(location)
    }
  }, [loading])

  useEffect(() => {
    if (!waiverSigned && waiverUrl) {
      setShowWaiver(true)
    }
  }, [waiverSigned, waiverUrl])

  useEffect(() => {
    const newDate = dayToDate(calendarDay)
    if (newDate !== selectDate) {
      setSelectDate(newDate)
    }
  }, [calendarDay])

  const handleWebsite = (url: string | null) => {
    if (url) {
      window.open(
        url.includes('https') ? url : `https://${url}`,
        '_blank',
        'noreferrer'
      )
    }
  }

  const handleContact = (phoneNumber: string | null) => {
    if (phoneNumber) {
      const newPhoneNumber = `tel: ${phoneNumber}`
      setContactButtonText(newPhoneNumber)
    }
  }
  const dayToDate = (date: Day) => new Date(date.year, date.month - 1, date.day)

  const handleCalendarMonthSelected = (date: Day) => {
    setCalendarDay(date)
    setCalendarToolbarDay(dayToDate(date))
  }

  const handleCalendarToolbarSelected = (date: Date) => {
    const newDate = {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    }
    setCalendarDay(newDate)
    setCalendarToolbarDay(date)
  }

  const getBookingCourtOptions = () => {
    const selectOptionsList: SelectTypes[] = [
      {
        value: '',
        label: 'Any court',
      },
    ]

    if (locationInfo && locationInfo.courts) {
      locationInfo.courts.map(option => {
        selectOptionsList.push({
          value: option.id.toString(),
          label: option.name,
        })
      })
    }
    return selectOptionsList
  }

  const handlePrograms = () => {
    push(`/locations/${params.locationId}/programs`)
  }

  const waiverValidations = () => {
    if (waiverSigned) {
      return true
    }
    if (!waiverSigned && !waiverUrl) {
      return true
    }
    if (!waiverSigned && waiverUrl) {
      return false
    }
  }

  const waiverSign = async () => {
    await dispatch(
      userActions.postWaiverStatusForUser({
        locationId: params?.locationId ?? '',
        userId: user?.id.toString() ?? '',
      })
    )
    setShowWaiver(false)
  }
  return (
    <>
      {showWaiver && waiverUrl && (
        <Modal title="Waiver">
          <iframe
            src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
              waiverUrl
            )}`}
            style={{
              marginTop: 16,
              width: '100%',
              height: '80vh',
              overflow: 'hidden',
            }}></iframe>
          <div
            style={{
              padding: 16,
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Button
              text="Cancel"
              variant="secondary"
              preset="filled"
              size={'small'}
              style={{ marginRight: 8 }}
              onClick={() => setShowWaiver(false)}
            />
            <Button
              text="Accept"
              variant="primary"
              preset="filled"
              size={'small'}
              onClick={() => waiverSign()}
            />
          </div>
        </Modal>
      )}
      {loadingFlg ? (
        <PageLoader />
      ) : (
        <FacilityVisitorContainer>
          <Breadcrumb breadcrumbPages={FACILITY_BREADCRUM} pageParam={'1'} />
          <FacilityVisitorItemContainer>
            <FacilityVisitorTitle>
              {locationInfo ? locationInfo.name : ''}
            </FacilityVisitorTitle>
          </FacilityVisitorItemContainer>

          <FacilityVisitorImageContainer>
            {/** Future implementation */}
            {/* <FacilityVisitorFavoriteContainer
          onClick={() => setFavorite(!favorite)}>
          <FacilityVisitorFavoriteTitle>
            Add to Favorites
          </FacilityVisitorFavoriteTitle>
          {!favorite ? <SVG src={heartOutline} /> : <SVG src={heart} />}
        </FacilityVisitorFavoriteContainer> */}
            <FacilityVisitorImage
              src={
                locationInfo && locationInfo.logo_url
                  ? locationInfo.logo_url
                  : ''
              }
            />
          </FacilityVisitorImageContainer>

          <FacilityVisitorItemContainer>
            <FacilityVisitorAddress>
              {locationInfo ? locationInfo.address : ''}
            </FacilityVisitorAddress>
            <FacilityVisitorLocationIconContainer>
              <MdLocationOn />
            </FacilityVisitorLocationIconContainer>
          </FacilityVisitorItemContainer>

          <FacilityVisitorItemContainer>
            <Button
              preset={'ghost'}
              variant={'neutral'}
              text={contactButtonText}
              size={'medium'}
              style={{ marginRight: '15px' }}
              onClick={() =>
                handleContact(locationInfo ? locationInfo.phone_number : null)
              }
            />

            <Button
              preset={'ghost'}
              variant={'neutral'}
              text={'Website'}
              size={'medium'}
              style={{ marginRight: '15px' }}
              onClick={() =>
                handleWebsite(locationInfo ? locationInfo.website_url : null)
              }
            />
          </FacilityVisitorItemContainer>

          <FacilityVisitorItemContainer
            style={{ width: 550, margin: '30px 0' }}>
            <FacilityVisitorDescription>
              {locationInfo ? locationInfo.description : ''}
            </FacilityVisitorDescription>
          </FacilityVisitorItemContainer>

          <FacilityVisitorCourtContainer>
            <Court
              qty={7}
              title={'Regular Court Schedule'}
              price={14.99}
              onHandlePrograms={handlePrograms}
            />
          </FacilityVisitorCourtContainer>

          <FacilityVisitorCalendarContainer>
            <FacilityVisitorCalendarSubContainer>
              <CalendarMonth
                currentDate={calendarDay}
                onSelectedDate={date => handleCalendarMonthSelected(date)}
              />
            </FacilityVisitorCalendarSubContainer>
            <FacilityVisitorRightContainer>
              <FacilityVisitorToolbarContainer>
                <CalendarToolbar
                  currentDate={calendarToolbarDay}
                  onSelectedDate={date => handleCalendarToolbarSelected(date)}
                />
              </FacilityVisitorToolbarContainer>
              {waiverValidations() && (
                <BookingCourt
                  date={selectDate}
                  options={getBookingCourtOptions()}
                  locationInfo={locationInfo}
                />
              )}
            </FacilityVisitorRightContainer>
          </FacilityVisitorCalendarContainer>
        </FacilityVisitorContainer>
      )}
    </>
  )
}

export default FacilityVisitor
